











import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import serverContextService from '@/core/serverContext.service';

@Component
export default class cIcon extends Vue {
    @Prop({
        type: String,
        required: true
    })
    name!:string;

    @Prop({
        type: String
    })
    height!:string;

    @Prop({
        type: String
    })
    width!:string;

    @Prop()
    original!: string;

    @Prop()
    alt!: string;

    @Prop()
    title!: string;

    @Prop()
    color;

    @Prop()
    fill;

    get nameComputed() {
        const opremaPrefixedIcons = new Set(['logo', 'logo-half-eet', 'logo-half-top', 'lyn1', 'lyn2', 'lyn3', 'splash-new']);
        if (serverContextService.themeString && opremaPrefixedIcons.has(this.name)) {
            return `${serverContextService.themeString}-${this.name}`;
        }
        return this.name;
    }

    get altText(): string {
        return this.alt || this.title || this.name;
    }
}
